import { Progress } from "antd";
import { useEffect, useState } from "react";
import { Chart } from "react-google-charts";
import NoDataComponent from "../NoDataComponent";

export default function GeoChart(props: any) {
  const {
    progressBarColor = "#2F69CC",
    textColor = "#2F69CC",
    data,
    options,
    showProgressBars = true,
  } = props;

  const [progressBarData, setProgressBarData] = useState([]);
  const totalValueHandler = (filteredData: any) => {
    const values = filteredData.reduce(
      (accumulator: any, currentItem: any) => accumulator + currentItem[1],
      0
    );
    const average = Number(values) / filteredData?.length;
    return average;
  };
  const handleProgressBarData = () => {
    const filteredData = JSON.parse(JSON.stringify(data));
    filteredData.shift();
    const totalValue = filteredData.reduce(
      (sum: number, item: [string, number]) => sum + Number(item[1]),
      0
    );
    // const totalValue = 2700;
    const progressBarDataTemp = filteredData.map((item: any) => {
      const percentageOfValue = (Number(item[1]) / totalValue) * 100;
      return { barName: item[0], percentage: percentageOfValue };
    });
    setProgressBarData(progressBarDataTemp);
  };

  useEffect(() => {
    handleProgressBarData();
  }, [data]);

  return data && data.length ? (
    <>
      <div className="flex flex-col gap-2">
        <Chart
          chartEvents={[
            {
              eventName: "select",
              callback: ({ chartWrapper }: any) => {
                const chart = chartWrapper.getChart();
                const selection = chart.getSelection();
                if (selection.length === 0) return;
                const region = data[selection[0].row + 1];
              },
            },
            {
              eventName: "ready",
              callback: ({ chartWrapper }: any) => {
                const chart = chartWrapper.getChart();
                const selection = chart.getSelection();
                if (selection.length === 0) return;
                const region = data[selection[0].row + 1];
              },
            },
          ]}
          chartType="GeoChart"
          width="100%"
          height="306px"
          data={data}
          options={options}
        />
        {/* progress bars  */}
        {showProgressBars && (
          <div className="w-full grid md:grid-cols-2 grid-cols-1 gap-x-16 gap-y-1 overflow-auto max-h-[226px]">
            {progressBarData && progressBarData?.length
              ? progressBarData.map((item: any, index: number) => (
                  <div
                    key={index + item.barName}
                    className="flex flex-col gap-0.25 w-full"
                  >
                    <div className="flex justify-between w-full ">
                      <span
                        className={`font-medium text-sm text-poppins ]`}
                        style={{ color: textColor }}
                      >
                        {item.barName}
                      </span>
                      <span className="text-sm text-poppins">
                        {Math.round(item.percentage)}%
                      </span>
                    </div>
                    <Progress
                      percent={item.percentage}
                      status="active"
                      showInfo={false}
                      strokeColor={progressBarColor}
                    />
                  </div>
                ))
              : null}
          </div>
        )}
      </div>
    </>
  ) : (
    <div className="h-[532px]">
      <NoDataComponent />
    </div>
  );
}
